var _defs, _rect, _text, _text2, _rect2, _text3, _text4, _text5, _rect3, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _line, _rect4, _text14, _text15, _text16, _text17, _text18, _text19, _rect5, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _line2, _rect6, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _rect7, _text35, _text36, _text37, _text38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase4Fig2ConventionToMechanism(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arr",
    markerWidth: 8,
    markerHeight: 8,
    refX: 7,
    refY: 4,
    orient: "auto",
    markerUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,4 L0,8 Z",
    fill: "#6B7F74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 600,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Convention to mechanism")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Three generations of one control, with the failure that produced each.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 140,
    width: 280,
    height: 320,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 176,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "GENERATION 1")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 176,
    textAnchor: "end",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "FAILED")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 212,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Prose rule")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 232,
    width: 232,
    height: 66,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1,
    strokeDasharray: "6 4"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 260,
    fontSize: 12.5,
    fontStyle: "italic",
    fill: "#4A5F56"
  }, "&#8220;present next steps")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 280,
    fontSize: 12.5,
    fontStyle: "italic",
    fill: "#4A5F56"
  }, "as a checklist&#8221;")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 330,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "A convention held in prose,")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 349,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "applied from memory,")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 368,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "enforced by attention.")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 232,
    textAnchor: "middle",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "FAILURE")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 254,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#4A5F56"
  }, "the prose rule was")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 271,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#4A5F56"
  }, "skipped under load")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 338,
    y1: 300,
    x2: 444,
    y2: 300,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arr)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 140,
    width: 280,
    height: 320,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 484,
    y: 176,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "GENERATION 2")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 716,
    y: 176,
    textAnchor: "end",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#D97706"
  }, "SUPERSEDED")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 484,
    y: 212,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Stop hook")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 484,
    y: 238,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Fires mechanically on")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 484,
    y: 257,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "every stop.")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 484,
    y: 290,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "THE RECORDED REASON")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 300,
    width: 232,
    height: 112,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1,
    strokeDasharray: "6 4"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 496,
    y: 324,
    fontSize: 12,
    fontStyle: "italic",
    fill: "#4A5F56"
  }, "&#8220;a subjective")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 496,
    y: 342,
    fontSize: 12,
    fontStyle: "italic",
    fill: "#4A5F56"
  }, "did-I-finish-a-significant-task")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 496,
    y: 360,
    fontSize: 12,
    fontStyle: "italic",
    fill: "#4A5F56"
  }, "gate is rationalized away")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 496,
    y: 378,
    fontSize: 12,
    fontStyle: "italic",
    fill: "#4A5F56"
  }, "exactly when busy&#8221;")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 806,
    y: 232,
    textAnchor: "middle",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "FAILURE")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 806,
    y: 254,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#4A5F56"
  }, "firing on every stop")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 806,
    y: 271,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#4A5F56"
  }, "produced noise on")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 806,
    y: 288,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#4A5F56"
  }, "no-work turns")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 300,
    x2: 856,
    y2: 300,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arr)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 872,
    y: 140,
    width: 280,
    height: 320,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 176,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "GENERATION 3")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 1128,
    y: 176,
    textAnchor: "end",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "SURVIVING")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 212,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Hook plus noise gate")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 238,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "The same Stop hook,")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 257,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "now behind a git")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 276,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "work-delta noise gate.")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 308,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "DESIGN STANCE")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 318,
    width: 232,
    height: 44,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1,
    strokeDasharray: "6 4"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 908,
    y: 345,
    fontSize: 13,
    fontWeight: 600,
    fontStyle: "italic",
    fill: "#1A2F2A"
  }, "&#8220;fails toward blocking&#8221;")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 394,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "If the gate errors, the")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 413,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "hook still fires.")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 552,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Each generation encodes the documented failure of the generation before it.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase4Fig2ConventionToMechanism);
export default __webpack_public_path__ + "static/media/case4-fig2-convention-to-mechanism.3d13a9decb0b542f30d8ec310c449c30.svg";
export { ForwardRef as ReactComponent };